module.exports = __webpack_public_path__ + "static/media/chat.e9a6acf7.svg";